module.exports = __webpack_public_path__ + "img/ft_calcium_carbonate.043ed649.jpg";